function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

class QuantityInput extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector('input');
		this.changeEvent = new Event('change', { bubbles: true });
		this.minusButton = this.querySelector('button[name="minus"]');
		this.plusButton = this.querySelector('button[name="plus"]');

		this.querySelectorAll('button').forEach(
			(button) => button.addEventListener('click', this.onButtonClick.bind(this))
		);

		this.input.addEventListener('input', this.onInputChange.bind(this));
	}

	onButtonClick(event) {
		event.preventDefault();
		const previousValue = this.input.value;

		event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
		if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

		this.updateButtonStates();
	}

	onInputChange() {
		let value = parseInt(this.input.value, 10);
		const min = parseInt(this.input.min, 10) || 1;
		const max = this.input.max ? parseInt(this.input.max, 10) : Infinity;

		if (isNaN(value)) {
			value = min;
		} else {
			value = Math.max(min, Math.min(max, value));
		}

		this.input.value = value;
		this.input.dispatchEvent(this.changeEvent);

		this.updateButtonStates();
	}

	updateButtonStates() {
		const value = parseInt(this.input.value, 10);
		const min = parseInt(this.input.min, 10) || 1;
		const max = this.input.max ? parseInt(this.input.max, 10) : Infinity;

		value <= min
			? this.minusButton.setAttribute('disabled', 'disabled')
			: this.minusButton.removeAttribute('disabled');

		value >= max
			? this.plusButton.setAttribute('disabled', 'disabled')
			: this.plusButton.removeAttribute('disabled');
	}
}

customElements.define('quantity-input', QuantityInput);




function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

class Cart extends HTMLElement {
  constructor() {
    super();
    
    this.debouncedOnSubmit = debounce((event) => {
      this.updateQuantity(event)
    }, 800);
    
    this.addEventListener('change', this.updateQuantity.bind(this))
    this.addEventListener('input', this.debouncedOnSubmit.bind(this))
    this.applyDiscount()
  }
  
  applyDiscount() {

    if (document.querySelector('.checkout-button')?.hasAttribute('data-discount')) {
      fetch(`/discount/${document.querySelector('.checkout-button')?.getAttribute('data-discount')}`).then(async () => {
        // update cart
        // const data = await fetch(`/cart?section_id=cart-template`).then(response => response.text());
        // // const newCart = new DOMParser().parseFromString(data, 'text/html');
        // console.log(data)
        // this.renderCart(newCart, false)
      });
    }
	}
  
  updateQuantity(event) {
    event.preventDefault()
    
    const sectionsId = 'cart-template'
    const config = fetchConfig('javascript')
    const id = event.target.getAttribute('data-line-key')
    let quantity
    
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    
    if (event.target.tagName === 'INPUT') {
      quantity = parseInt(Math.max(parseInt(event.target.value) || 1, 1));
    } else {
      quantity = parseInt(event.target.getAttribute('data-quantity'));
    }
    
    config.body = JSON.stringify({
      updates: {
        [id]: quantity,
      },
      sections: sectionsId,
      sections_url: window.location.pathname
    });
    
    fetch(`${routes.cart_update_url}`, config)
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        const cartHTML = new DOMParser().parseFromString(json.sections[sectionsId], 'text/html');
        
        const itemsToRemove = json.items.filter((item) => {
          const hasConnectedProduct = json.items.some((cart_item) => {
            const checkCustomizeProducts = cart_item.properties?.['_Preview Image'] && cart_item.variant_title === item.properties?.['_For Product'] && cart_item.id == item.properties?._variant_id
            const checkRegularProducts = item.properties?.['_related-uniq-id'] && cart_item.properties?.['_uniq-id'] === item.properties?.['_related-uniq-id']
            
            if (item.product_type == 'Fee') {
              console.log(cart_item.properties?.['_Preview Image'])
            }
            return checkCustomizeProducts || checkRegularProducts
          });
          
          return item.product_type == 'Fee' && !hasConnectedProduct;
        })
        
        
        
        if (itemsToRemove.length) {
          const updatesObj = {}
  
          itemsToRemove.forEach(item => {
            updatesObj[item.key] = 0
          })
  
          config.body = JSON.stringify({
            updates: updatesObj,
            sections: sectionsId,
            sections_url: window.location.pathname
          });
  
          fetch(`${routes.cart_update_url}`, config)
            .then((response) => {
              return response.json();
            })
            .then((json) => {
              const cartHTML = new DOMParser().parseFromString(json.sections[sectionsId], 'text/html');
              this.renderCart(cartHTML, false)
            })
        } else {
          this.renderCart(cartHTML, false)
        }
        
  
      })
      .catch((error) => {
        console.error(error);
      })
  }
  
  renderCart(responseHTML, openCart) {
    if (!responseHTML) {
      return
    }
  
  
    const cartBody = document.querySelector('.cart__wrapper')
    const cartBodyNew = responseHTML.querySelector('.cart__wrapper').innerHTML
  
    cartBody.innerHTML = cartBodyNew;
  
    checkAgreement()
  }
}

customElements.define('cart-section', Cart);

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      this.closest('cart-section').updateQuantity(event, false);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

document.addEventListener('change', (e) => {
  if (e.target.closest('#agree')){
    if (e.target.checked) {
      sessionStorage.setItem('agreement', 'true')
  
    } else {
      sessionStorage.removeItem('agreement')
    }
  }
}, false);

document.addEventListener('DOMContentLoaded', () => {

  document.addEventListener('click', (e) => {
    console.log(e, 'qq')
    if (e.target.closest('.js-check-agreement')){
      console.log(1)
      if (!document.getElementById('agree').checked) {
        e.preventDefault();
    
        console.log(2)
    
    
        document.getElementById('agree').classList.add('error')
    
        setTimeout(function () {
          document.getElementById('agree').classList.remove('error')
        }, 2000)
      }
      
    }
  });
  
  document.addEventListener('click', (e) => {
    if (e.target.closest('.clear-cart')){
      console.log(1)
      fetch(`/cart/clear`).then(async () => {
        window.location.href = '/'
      });
    }
  })
})

function checkAgreement () {
  if (sessionStorage.getItem('agreement') && document.getElementById('agree') !== null) {
    document.getElementById('agree').checked = true
  }
}

checkAgreement()